import { useTheme } from '@emotion/react'
import {
  animated,
  useTrail,
  useSpring,
  useChain,
  useSpringRef,
} from 'react-spring'
import { useInView } from 'react-intersection-observer'
import { DEFAULT_SPRING_CONFIG } from '@/lib/springComponent'

import { GetStartedItem } from './GetStartedItem'
import { ITEMS } from './constants'

const AnimatedItem = animated(GetStartedItem)

type Props = {
  id?: string
}

export function GetStarted({ id }: Props) {
  const theme = useTheme()

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  })

  const springRef = useSpringRef()
  const trailRef = useSpringRef()

  const headerSpring = useSpring({
    transform: inView ? 'translate3d(0, 0px, 0)' : 'translate3d(0, 32px, 0)',
    opacity: inView ? 1 : 0,
    ref: springRef,
  })

  const trails = useTrail(ITEMS.length, {
    transform: inView ? 'scale(1)' : 'scale(0.9)',
    opacity: inView ? 1 : 0,
    config: DEFAULT_SPRING_CONFIG,
    ref: trailRef,
  })

  useChain([springRef, trailRef], [0, 1])

  return (
    <section
      id={id}
      ref={ref}
      css={theme.mq({
        ...theme.layerStyles.landingSectionContainer,
      })}
    >
      <animated.h2
        style={headerSpring}
        css={theme.mq({ ...theme.textStyles.landingSectionHeader })}
      >
        เริ่มต้นง่าย ๆ ไดัทันที
      </animated.h2>
      <div
        css={theme.mq({
          display: 'grid',
          gridTemplateColumns: {
            base: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(4, 1fr)',
          },
          gridGap: { base: '--space-12', md: '--space-7' },
          justifyItems: 'center',
        })}
      >
        {ITEMS.map((item, index) => {
          return (
            <AnimatedItem
              key={`${index}`}
              style={trails[index]}
              index={index}
              sx={{
                transform: 'scale(0.9)',
                opacity: 0,
              }}
              {...item}
            />
          )
        })}
      </div>
    </section>
  )
}
